import React from 'react';

const AuthContext = React.createContext({
  role: "",
  designation: "",
  user: {},
  setUser: () => {},
  logout: () => {},
});

export default AuthContext;
